<ul>
    <li>
        <a mat-button class="toggle" *ngIf="this.authService.currentUser().ROLE == authRole.ExternalAdmin || this.authService.currentUser().ROLE == authRole.ExternalUser || this.authService.currentUser().ROLE == authRole.Public" (click)="externalNewRequest(false)">
            <mat-icon>open_in_browser</mat-icon>
            {{'stpr_Request' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
        </a>
        <a mat-button class="toggle" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin || this.authService.currentUser().ROLE == authRole.InternalUser" (click)="toggleRequestMenu()">
            <mat-icon>open_in_browser</mat-icon>
            {{'stpr_Request' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
            <mat-icon *ngIf="!showRequestMenu">chevron_right</mat-icon>
            <mat-icon *ngIf="showRequestMenu">expand_more</mat-icon>
        </a>
        <mat-nav-list class="sidenav-submenu" *ngIf="showRequestMenu">
            <a mat-list-item (click)="route('newRequest')">
        {{'NewRequest' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqManList')">
        {{'ManualRequest' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
        </mat-nav-list>
    </li>

    <li>
        <a mat-button class="toggle" *ngIf="this.authService.currentUser().ROLE == authRole.ExternalAdmin || this.authService.currentUser().ROLE == authRole.ExternalUser || this.authService.currentUser().ROLE == authRole.Public" (click)="route('statisticGrid')">
            <mat-icon>assessment</mat-icon>
            {{'Statistics' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
        </a>
        <a mat-button class="toggle" (click)="toggleStatisticMenu()" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin || this.authService.currentUser().ROLE == authRole.InternalUser">
            <mat-icon>assessment</mat-icon>
            {{'Statistics' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
            <mat-icon *ngIf="!showStatisticMenu">chevron_right</mat-icon>
            <mat-icon *ngIf="showStatisticMenu">expand_more</mat-icon>
        </a>
        <mat-nav-list class="sidenav-submenu" *ngIf="showStatisticMenu">
            <a mat-list-item (click)="route('statisticGrid')">
        {{'GIP_REQ_STAT_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatCList')">
        {{'GIP_REQ_STAT_C_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatCaList')">
        {{'GIP_REQ_STAT_CA_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatSList')">
        {{'GIP_REQ_STAT_S_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatCsList')">
        {{'GIP_REQ_STAT_CS_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatAList')">
        {{'GIP_REQ_STAT_A_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipReqStatEList')">
        {{'GIP_REQ_STAT_E_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
        </mat-nav-list>
    </li>

    <li>
        <a mat-button class="toggle" *ngIf="this.authService.currentUser().ROLE == authRole.ExternalAdmin" (click)="route('gipUserList')">
            <mat-icon>supervisor_account</mat-icon>
            {{'GIP_USER_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
        </a>
        <a mat-button class="toggle" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin || this.authService.currentUser().ROLE == authRole.InternalUser" (click)="toggleAdminMenu()">
            <mat-icon>supervisor_account</mat-icon>
            {{'AdmContentList' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
            <mat-icon *ngIf="!showAdminMenu">chevron_right</mat-icon>
            <mat-icon *ngIf="showAdminMenu">expand_more</mat-icon>
        </a>
        <mat-nav-list class="sidenav-submenu" *ngIf="showAdminMenu">
            <a mat-list-item (click)="route('gipUserList')">
        {{'GIP_USER_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipAdmDocenvList')" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin">
        {{'GIP_ADM_DOCENV_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipAdmDocpubList')" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin">
        {{'GIP_ADM_DOCPUB_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipAdmPropsList')" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin">
        {{'GIP_ADM_PROPS_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipAdmTextList')" *ngIf="this.authService.currentUser().ROLE == authRole.InternalAdmin">
        {{'GIP_ADM_TEXT_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipCompanyList')">
        {{'GIP_COMPANY_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
            <a mat-list-item (click)="route('gipContractList')">
        {{'GIP_CONTRACT_LIST' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </a>
        </mat-nav-list>
    </li>

</ul>